import "vite/modulepreload-polyfill";

import * as React from "react";
import { createRoot } from "react-dom/client";
import ProcessMapTool from "./process-map/ProcessMapTool";
import {
  ProcessMapData,
  ProcessMapWindow,
} from "./process-map/ProcessMap.types";

declare var window: ProcessMapWindow;

document.addEventListener("DOMContentLoaded", () => {
  const container = document.getElementById("process-map") as HTMLDivElement;

  if (container) {
    const data: ProcessMapData = window.processMapData || {
      title: "",
      layers: [],
      hotSpots: [],
      content: "",
      id: 0,
    };

    const root = createRoot(container);
    root.render(
      <React.StrictMode>
        <ProcessMapTool {...data} />
      </React.StrictMode>
    );
  }
});
